import { Box, Stack, Typography } from "@mui/material";
import { Component } from "react";
import GetIcon from "./GetIcon.tsx";

export default class Window extends Component {

    render() {
        return (
            <Box maxWidth={!this.props.full ? '1200px' : 'unset'}
                paddingRight={{md: '10px', xs: '5px'}}
                paddingLeft={{md: '10px', xs: '5px'}}
                sx={{
                    width: '100%',
                    height: 'calc(100% - 18px)',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: '58px',
                    overflowX: 'hidden'
                }}>
                <Stack direction="row" sx={{ color: "primary.main" }} gap={1}><GetIcon props={{ size: 24 }} icon={this.props.icon} /><Typography level="body-md"><b>{this.props.title}</b></Typography></Stack>
                <Stack height={'calc(100% - 40px)'} sx={{ overflowY: 'hidden' }}>
                    {this.props.children}
                </Stack>
            </Box>
        );
    }
}